export const extractEnabledPermissions = (rawPermissions) => {
    const enabled_permissions = [];

    rawPermissions.forEach(obj => {
        for (const key in obj) {
            if (obj[key] === true) {
            enabled_permissions.push(key.toLowerCase());
            }
        }
    });
    
    return enabled_permissions;
};